import { render, staticRenderFns } from "./EditTeaching.vue?vue&type=template&id=7b7cccca&scoped=true&"
import script from "./EditTeaching.vue?vue&type=script&lang=js&"
export * from "./EditTeaching.vue?vue&type=script&lang=js&"
import style0 from "./EditTeaching.vue?vue&type=style&index=0&id=7b7cccca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7cccca",
  null
  
)

export default component.exports